import { render, staticRenderFns } from "./CardActions.vue?vue&type=template&id=0b960976&scoped=true&"
import script from "./CardActions.vue?vue&type=script&lang=js&"
export * from "./CardActions.vue?vue&type=script&lang=js&"
import style0 from "./CardActions.vue?vue&type=style&index=0&id=0b960976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b960976",
  null
  
)

export default component.exports